import React from 'react'
import styled from 'styled-components';



const Container = styled.footer`
    display:flex;
    justify-content: space-evenly;
    width:100%;
    height:40vh;
    position:absolute;
    left:0;
    right:0;
    
    z-index:150;
    background-color:#232323;
    margin-top:250px;
    @media screen and (max-width:420px){
        margin-top:1600px;
    }
`;
const Left = styled.div`
    flex:1;
   margin-left:5%;
`
const Centre = styled.div`
    
    align-items:center;
`;
const Right = styled.div`
    flex:1;
`;
const Logo = styled.h1`
    color:white;    
`;
const ParaLeft1 = styled.p`
    color:white;
   
`;
const ParaLeft2 = styled.p`
    color:white;
    
`;
const Footer = () => {
  return (
    <Container>
        
        <Left>
           
        </Left>
        <Centre>
           
        
        <Logo>Ammunition</Logo>
            <ParaLeft1>We Are The Largest And Most Reliable Firearms Dealer In Pakistan</ParaLeft1>
            <ParaLeft2>Copyright © 2022 Tactical Bazar. All Rights Reserved.</ParaLeft2>
        </Centre>
        <Right>
           
        </Right>

    </Container>
  )
}

export default Footer